import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Badge from 'components/field/Badge';
import Button from 'components/field/Button';
import Icon from 'components/global/Icon';
import Tooltip from 'components/global/Tooltip';
import Typography from 'components/global/Typography';

import { selectModule } from 'pages/OTOModules/OTOPackageListSlice';

import PATHS from 'utils/paths';

import { faCheck } from '@fortawesome/pro-light-svg-icons';

import * as S from './OTOModules.styled';

const ModuleCard = ({ module }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const handleModuleClick = () => {
		dispatch(selectModule(module));
		navigate(`${PATHS.OTO_MODULES}/${module.slug}`);
	};
	return (
		<S.ModuleCard key={module.id} id={module.packageRoleID}>
			<S.ModuleItem>
				<S.ModuleImage url={module.moduleIcon} alt={module.slug} width="6.4rem" height="6.4rem" />
				<S.ModuleContent>
					<S.ModuleInfo>
						<S.ModuleHeader>
							<S.ModuleTitle>
								<Typography variant="p3" fontWeight="500" noWrap>
									{module.slug}
								</Typography>
								{module.isNew && <Badge variant="pill" size="small" color="red" text="new" />}
							</S.ModuleTitle>
							{module.active && (
								<Tooltip title="activeModule" placement="top">
									<S.CheckedIcon>
										<Icon icon={faCheck} color="var(--white)" />
									</S.CheckedIcon>
								</Tooltip>
							)}
						</S.ModuleHeader>
						<Badge variant="pill" size="small" color="light" text={module.category} />
					</S.ModuleInfo>

					<Typography
						variant="p3"
						color="var(--content-3)"
						maxlines={3}
						noWrap
						css={{ lineHeight: '2.4rem' }}>
						{`${module.slug}.description`}
					</Typography>
					<S.Actions>
						<Button
							id={`${module?.slug}-viewDetailsButton`}
							variant="outline"
							size="small"
							fullWidth
							label="viewDetails"
							onClick={handleModuleClick}
						/>
					</S.Actions>
				</S.ModuleContent>
			</S.ModuleItem>
		</S.ModuleCard>
	);
};

export default ModuleCard;
